import { InteractiveImage } from "./InteractiveImage";

export default class Trophy extends InteractiveImage {
  private readonly pointerDownImpl: () => void;

  constructor(scene: Phaser.Scene, x: number, y: number, texture: string) {
    super(scene, x, y, texture, "Reviews");

    this.pointerDownImpl = () => {
      history.pushState({}, '', 'reviews');
      setTimeout(() => scene.events.emit("showTrophy"), 100);
    }
  }

  pointerDown(): void {
    this.pointerDownImpl();
  }
}
